import { render, staticRenderFns } from "./leftColGuardarA.vue?vue&type=template&id=013f9b70"
import script from "./leftColGuardarA.vue?vue&type=script&lang=js"
export * from "./leftColGuardarA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports